import { Observable } from 'rxjs';

export interface RRIAuthService {
  getToken$: () => Observable<string>;
}
